import { Loader2 } from 'lucide-react'
import type { ButtonHTMLAttributes, ReactNode } from 'react'
import { useTheme } from '@/storefront/theme/ThemeContext'

type Variant = 'primary' | 'outline'

export function Button({
  variant = 'primary',
  className = '',
  children,
  loading,
  type,
  disabled,
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant
  children: ReactNode
  loading?: boolean
}) {
  const theme = useTheme()
  const cls =
    variant === 'primary' ? 'ref-btn ref-btn-primary' : 'ref-btn ref-btn-outline'
  const themeBtn = theme.components.button
  const isLoading = loading === true
  return (
    <button
      type={type ?? 'button'}
      className={`${cls} ${themeBtn} ${className}`.trim()}
      disabled={isLoading || disabled}
      aria-busy={isLoading || undefined}
      {...rest}
    >
      {isLoading ? (
        <>
          <Loader2 className="h-4 w-4 shrink-0 animate-spin" aria-hidden />
          <span className="sr-only">Chargement</span>
        </>
      ) : (
        children
      )}
    </button>
  )
}
